var handle_array = ["a-test-product","product-two"];
 var hide_price=1;
 var hide_ajaxaddtocart=1;
 var display_phone=1;
 var phone_no = '(800) 233-0298';
 var display_call_for_price = 1;
 var call_for_price_label = 'Call for Price';
 var css_style_button='background-color: #e79600;color:#000;width:auto;height:45px;border-radius: 45px;font-size: 15px;box-shadow: none;transition: 0.3s;padding: 10px 55px;font-weight:600;line-height:26px;margin-bottom: 30px;';
 var enabled_captcha = 0;
 var site_key = '';
 var thankyou_msg = 'Your Request Submitted Successfully.';
 var thankyou_header = 'Success';
 var name_label='Name';
 var email_label='Email';
 var phone_label = ' Phone Number';
 var comment_label = 'Comment';
 var submit_label ='Submit';
  var error_name_label='Please fill out this field.';
 var error_email_label='Please fill out this field.';
 var error_phone_label = 'Please fill out this field.';
 var error_comment_label = 'Please fill out this field.';
 var enable_app =1;
  var enable_outofstock = 1;
 var price_selector='.price-box';
 var cart_selector='.single_add_to_cart_button';
  var phone_no_label = 'Call for Price:';
 var required_field='name,email,comment';
 var contact_form_heading='Call for Price for';
 var parent_selector='.summary-inner';
 var unavailable_label='Unavailable';
